export enum PermissionType {
  Base = 'CPM',
  Video = 'VID',
  Tutorial = 'TUT',
  Note = 'NTE',
  LegacyExam = 'EXM',
  ClassQuiz = 'CQZ',
}

export enum PermissionSource {
  Direct = 'DIRECT',
}
